var _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgIUploadSm = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -25.659)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    transform: "translate(0 25.659)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(19.809 -39.347)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-8.354,70.263a.5.5,0,0,1-.355-.147l-2.885-2.9-2.92,2.9a.5.5,0,0,1-.707,0,.5.5,0,0,1,0-.707l3.274-3.257a.5.5,0,0,1,.352-.146h0a.5.5,0,0,1,.354.148L-8,69.411a.5.5,0,0,1,0,.707A.5.5,0,0,1-8.354,70.263Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-11.593,76.776a.5.5,0,0,1-.5-.5V66.524a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v9.752A.5.5,0,0,1-11.593,76.776Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-7.54,79.218h-8.141a2.13,2.13,0,0,1-2.128-2.128V73.427a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5V77.09a1.129,1.129,0,0,0,1.128,1.128H-7.54A1.129,1.129,0,0,0-6.412,77.09V73.427a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5V77.09A2.13,2.13,0,0,1-7.54,79.218Z"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIUploadSm, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/i_upload_sm.7e801fa9.svg";
export { ForwardRef as ReactComponent };